import React, { useState } from 'react';
import { Alert, Button, Modal, Input, Field } from '../../../core/ui';
import { useTranslation } from '../../../core/context/TranslationContext';
import { createInvitation } from '../api/family';
import styles from './InviteCreateModal.module.css';

export default function InviteCreateModal({ show, onHide, onCreated }) {
  const { t } = useTranslation();
  const [expiresInHours, setExpiresInHours] = useState('');
  const [maxUses, setMaxUses] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCreate = async () => {
    try {
      setLoading(true);
      setError(null);
      const payload = {};
      if (expiresInHours) payload.expiresInHours = parseInt(expiresInHours, 10);
      if (maxUses) payload.maxUses = parseInt(maxUses, 10);
      const invitation = await createInvitation(payload);
      await navigator.clipboard.writeText(invitation.url);
      onCreated?.(invitation);
      handleClose();
    } catch (err) {
      setError(err.response?.data?.message || t('error'));
      setLoading(false);
    }
  };

  const handleClose = () => {
    setExpiresInHours('');
    setMaxUses('');
    setError(null);
    onHide();
  };

  return (
    <Modal
      open={show}
      onClose={handleClose}
      title={t('family.invite.create')}
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>{t('cancel')}</Button>
          <Button variant="primary" onClick={handleCreate} disabled={loading}>
            {loading ? t('loading') : t('family.invite.create')}
          </Button>
        </>
      }
    >
      {error && <Alert variant="danger">{error}</Alert>}
      <Field label={t('family.invite.expires.in')} className={styles.field}>
        <Input
          type="number"
          min="1"
          placeholder={t('family.invite.expires.never')}
          value={expiresInHours}
          onChange={(e) => setExpiresInHours(e.target.value)}
        />
      </Field>
      <Field label={t('family.invite.maxUses.none')} className={styles.field}>
        <Input
          type="number"
          min="1"
          placeholder={t('family.invite.maxUses.none')}
          value={maxUses}
          onChange={(e) => setMaxUses(e.target.value)}
        />
      </Field>
    </Modal>
  );
}
